<fts-grouporder-invitation (done)="handleDone()"
  [groupOrder]="groupOrder"
  [groupOrderingFriends]="groupOrderingFriends"
  [invitationDialogConfig]="invitationDialogConfig"
  [changeExpirationMode]="changeExpirationMode"></fts-grouporder-invitation>
